import { useState, useContext } from "react";
import axios from "axios";
import Loader from "./Loader";
import { AuthContext}  from '../../../hoc/AuthContext'

const API_BASE_URL = process.env.REACT_APP_TRANSLATION_API_BASE_URL;
const WMS_API_BASE_URL = process.env.REACT_APP_OLD_WMS_API_BASE_URL;



export default function TranslateBox({ output, setOutput, selectedProduct, selectedProductDetails }) {
  const [input, setInput] = useState("");
  //const [output, setOutput] = useState("");
  const [loading, setLoading] = useState(false);
  const { authUserData } = useContext(AuthContext)

  //console.log(authUserData.userData.id)

  function makeTitle(text, limit = 150) {
    if (text.length <= limit) return text; // no need to cut
    const trimmed = text.substring(0, limit);
    const lastSpace = trimmed.lastIndexOf(" ");
    return trimmed.substring(0, lastSpace) + "..."; // keep full words only
  }

  const handleTranslate = async () => {
    if (!input.trim()) return;    

    if(!authUserData.userData.id ) return alert('Please Sign-in Again!')

    setLoading(true);

    try {
      // ✅ Title without cutting words mid-way
      const safeTitle = makeTitle(input, 150);
      
       // 1. Log the input text BEFORE translation       
      await axios.post(`${WMS_API_BASE_URL}translation/log`, {
        product_id: selectedProductDetails.id || "22", // dynamic product_id
        user_id: authUserData.userData.id, // hardcoded for now, ideally dynamic
        title: safeTitle // take first 150 chars as title
      });

      const res = await axios.post(`${API_BASE_URL}translate/${selectedProduct}`, { text: input });
      setOutput(res.data.translated);
    } catch (err) {
      console.error("Translation failed:", err);
      setOutput("⚠️ Error translating.");
    }
    setLoading(false);
  };

  return (
    <div className="border p-4 rounded shadow bg-gray-50">
      <h2 className="text-xl font-semibold mb-2">🔄 Translate</h2>
      <textarea className="w-full p-2 border rounded" rows={4} value={input} onChange={(e) => setInput(e.target.value)} />
      <button
        onClick={handleTranslate}
        className={`mt-2 px-4 py-2 rounded text-white transition ${
          loading || !input.trim() ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
        }`}
        disabled={loading || !input.trim()}
      >
        {loading ? "Translating..." : "Translate"}
      </button>
      {loading ? (
        <Loader message="Translating..." />
      ) : output && (
        <div className="p-4 mt-4 bg-green-50 border rounded">
          <strong>Translated:</strong>
          <pre className="bg-gray-100 p-3 rounded whitespace-pre-wrap">{output}</pre>
        </div>
      )}
      
    </div>
  );
}
